<template>
    <div>
        <card-header title='New Conference' icon="fa-plus"/>

        <card-body>
            <rmc-conference-form :conference="conference"/>
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                        :disabled="!conference.title || !conference.code || !conference.start || !conference.end"
                    ><i class="fas fa-plus mr-2"></i>New Conference</b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";

    import CourseForm from "@/cards/courses/CourseForm";
    import RmcConferenceForm from "@/cards/RMC/conferences/ConferenceForm";

    import {client as http} from "@/http_client";

    export default {
        components: {RmcConferenceForm, CardHeader, CardToolbar, CardBody, CardFooter, CourseForm},
        props: ['card'],
        data() {
            return {
                conference: {
                    no_address: '0',
                    no_phone: '0',
                    allow_cc: 'true',
                    allow_po: 'false'
                }
            }
        },
        methods: {
            submit: function() {
                this.$emit('loading', true);
                http.post('rmc/conferences', this.conference, {force: true}).then(response => {
                    this.$reloadCard('rmc-conferences');
                    this.$closeCard(this.card);
                }).catch(err => {
                    if (err.response.status === 400) {
                        window.alert('Conference code must be unique. There is already a conference using that code.  Please choose a different once.');
                    } else {
                        window.alert('An error occurred while saving the conference.');
                    }
                    this.$emit('loading', false);
                });
            }
        }
    }
</script>
